// extracted by mini-css-extract-plugin
module.exports = {"option":"ComprehensionView_option__1Mrwp","img":"ComprehensionView_img__KamUq"};